import {UI} from "../../../../../stem-core/src/ui/UI";

import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {Messages} from "../../../../Messages";
import {WalletMerchantButton} from "../../../../common/MerchantButton";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {DEFAULT_DATE_FORMAT} from "../../../../Constants";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {SubscriptionIndexStyle} from "./SubscriptionIndex";
import {MessageElement} from "../../../ui/MessageElement";
import {startDonationFlow} from "../../../../panel/flows/startFlow";
import {PANEL_VARIANT} from "../../../../../blink-sdk/Constants";


class MerchantDonationStyle extends SubscriptionIndexStyle {
    @styleRule
    recurringDonor = {
        color: this.themeProps.DONATION_RECURRING_DONOR_COLOR,
        fontWeight: "bold",
        fontSize: 14,
        textAlign: "center",
    };

    @styleRule
    amountAndFrequency = {
        color: this.themeProps.DONATION_AMOUNT_FREQUENCY_COLOR,
        paddingLeft: 8,
        fontSize: 14,
    };

    @styleRule
    descriptionContainer = {
        fontSize: 14,
        color: this.themeProps.DONATION_DESCRIPTION_COLOR,
        marginTop: 12,
    };

    @styleRule
    supportMerchantMessage = {
        fontSize: 16,
        textAlign: "center",
        marginTop: 18,
    };

    @styleRule
    manageDonationContainer = {
        color: this.themeProps.MERCHANT_LINK,
        paddingLeft: 8,
        display: "inline-block",
        fontWeight: "inherit",
        textDecoration: "none",
    };

    @styleRule
    billingDateParagraph = {
        marginTop: 12,
    };
}

@autoredraw(iFrameUserDataService)
@registerStyle(MerchantDonationStyle)
export class DonationOverview extends UI.Element {
    renderPrimaryButton() {
        const {styleSheet} = this;

        return iFrameUserDataService.getActiveRecurringDonation() ? (
            iFrameMerchantService.getDonationOffer().getFrequencyOptions().find(frequency => frequency.isOneTime()) ?
            <WalletMerchantButton onClick={() => startDonationFlow(PANEL_VARIANT.skipCTA, true)}
                            className={styleSheet.button}>
                {Messages.makeAnotherDonation}
            </WalletMerchantButton> : null) :
            <WalletMerchantButton onClick={() => startDonationFlow()}
                            className={styleSheet.button}>
                {Messages.donate}
            </WalletMerchantButton>;
    }

    renderSecondaryButton() {
        return iFrameUserDataService.getActiveRecurringDonation() ?
            <Link onClick={() => startDonationFlow(PANEL_VARIANT.editRecurring)}
                  className={this.styleSheet.secondaryButton}>
                {Messages.editRecurringDonation}
            </Link> : null
    }

    renderActiveDonation() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        const nextBillingDate = donation.getNextBillingDate();

        return [
            <div className={styleSheet.recurringDonor}>{Messages.recurringDonor(donation.formatPrice())}</div>,
            <div className={styleSheet.descriptionContainer}>
                {nextBillingDate ?
                    <div className={styleSheet.billingDateParagraph}>{Messages.activeDonationDescription1(nextBillingDate.format(DEFAULT_DATE_FORMAT))}</div> : null}
                <MessageElement className={styleSheet.billingDateParagraph}
                                message={Messages.activeDonationDescription2(iFrameMerchantService.getMerchant().name)} />
            </div>,
        ];
    }

    renderNoDonation() {
        return <div className={this.styleSheet.supportMerchantMessage}>
            {Messages.supportByDonating(iFrameMerchantService.getMerchant().name)}
        </div>;
    }

    render() {
        return [
            iFrameUserDataService.getActiveRecurringDonation() ? this.renderActiveDonation() : this.renderNoDonation(),
            this.renderPrimaryButton(),
            this.renderSecondaryButton(),
        ];
    }
}
